import React from "react"
import Button from "@convertkit/design/button"
import mount from "core/mount"

export default function UpgradeToPaid() {
  return (
    <Button
      href="/account/upgrade"
      className="py-2 px-3 bg-blue-500 rounded hover:text-white hover:no-underline"
    >
      Upgrade
    </Button>
  )
}

mount({ UpgradeToPaid })
